/**
* @description Композитная HitArea. Позволяет задать для визуального объекта hitArea, состоящую из произвольного количества зон.
* @memberOf module:display
*/
class CompositeHitArea {
    constructor() {
        /** список зон */
        this.areas = [];
    }

    /** добавление новой зоны */
    add(area) {
        this.areas.push(area);
    }

    /** удаление зоны */
    remove(area) {
        var ix = this.areas.indexOf(area);
        if(ix >= 0) this.areas.splice(ix, 1);
    }

    /** очистка зон */
    clear() {
        this.areas = [];
    }

    /** проверка нахождения точки в зонах */
    contains(x, y) {
        for(let area of this.areas) {
            if(area.contains(x, y)) return true;
        }

        return false;
    }
}

export default CompositeHitArea;